(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-recommendations"] && !Shopify.designMode) return;
  try {
    class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.url = this.dataset.url;
    }

    connectedCallback() {
      if (!this.classList.contains('product-recommendations--loading')) {
        return;
      }
      this.loadRecommendations();
    }

    async loadRecommendations() {
      try {
        const response = await fetch(this.url);
        if (!response.ok) {
          this.remove();
          return;
        }

        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.classList.remove('product-recommendations--loading');
        } else {
          this.remove();
        }
      } catch (error) {
        this.remove();
      }
    }

    remove() {
      if (this.closest('.shopify-section')) {
        this.closest('.shopify-section').remove();
      } else {
        this.remove();
      }
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }
  } catch(e) { console.error(e); }
})();

})();
